module.exports = __webpack_public_path__ + "static/media/email.10233b28.svg";